/**
 * A closed account (its owner asked to delete it, launch redesign 3g): every API call but its status
 * and Restore answers 403 ACCOUNT_CLOSED. One screen, from whichever request noticed, offers Restore.
 */
export const ACCOUNT_CLOSED_EVENT = "lilia:account-closed";

export function announceAccountClosed() {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(ACCOUNT_CLOSED_EVENT));
}
